module.exports = __webpack_public_path__ + "img/phone.9ecef25e.svg";